import React, { useState } from "react";
import "./userQuestion.scss";

import { t } from "i18next";
import { useScreenSize } from "../../ScreenSizeContext";
import { Button, Form, Stack } from "react-bootstrap";
import { useParams } from "react-router-dom";

import HeaderBar from "../../components/headerBar/HeaderBar";
import UserBadge from "./components/userBadge/UserBadge";
import SuccessBadge from "./components/successBadge/SuccessBadge";
import { postUserQuestion } from "./api/userQuestionApi";
import { isEmpty } from "../../utils/validation";
import { gestioneSnackbar } from "../../utils/common";

const UserQuestion = () => {
  const isPC = useScreenSize();
  const { id_association } = useParams();

  const [question, setQuestion] = useState("");

  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isEmpty(question))
      return gestioneSnackbar(
        true,
        t("validation.mandatory_question"),
        "error"
      );

    postUserQuestion({ id_association, question })
      .then(() => setSuccess(true))
      .catch((err) => console.log(err));
  };

  return (
    <>
      <HeaderBar title={t("user_question.title")} back={true} />
      {!success ? (
        <Form onSubmit={handleSubmit} className="w-100">
          <div className="responsive-container">
            <Stack
              gap={5}
              className="d-flex justify-content-center align-items-center mt-4 w-100 p-3"
            >
              <UserBadge
                photo={localStorage.getItem("imageProfile") ?? null}
                name={localStorage.getItem("name")}
                surname={localStorage.getItem("surname")}
              />
              <Stack
                gap={3}
                className="d-flex justify-content-center align-items-center"
              >
                <Form.Group
                  controlId="questionId"
                  className={isPC ? "w-75" : "w-100"}
                >
                  <Form.Control
                    placeholder={t("user_question.question_field")}
                    as="textarea"
                    rows={5}
                    maxLength={255}
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                  />
                </Form.Group>
                <div className="d-flex justify-content-center">
                  <Button
                    variant="success"
                    type="submit"
                    className="w-100 rounded-5"
                  >
                    {t("user_question.send_question")}
                  </Button>
                </div>
              </Stack>
            </Stack>
          </div>
        </Form>
      ) : (
        <SuccessBadge />
      )}
    </>
  );
};

export default UserQuestion;
